/*
 * Copyright © 2017-Present, The Freshwater Trust, all rights reserved.
 */

import {GenericModelUtils} from "../../../Utils/GenericModelUtils";
import {RequiredValidator} from "./RequiredValidator";

export class PrimaryKeyRequiredValidator extends RequiredValidator {
	constructor() {
		super();
	}

	name(model) {
		return "Is required"
	}

	logic(_, model, data) {
		const primaryKeyValue = GenericModelUtils.getModelPrimaryKeyValue(model, data);
		return super.logic(primaryKeyValue, model, data) || GenericModelUtils.modelDataHasTempId(data);
	}

	message(model) {
		return "Required (PK " + GenericModelUtils.getModelPrimaryKeyName(model) + ")";
	}
}
